"use client";
import type { SelectType } from "@/types";
import Image from "next/image";
import { useState } from "react";
import VideoCardDescription from "../Cards/VideoCardDescription";
import SelectInput from "../SelectInput";

interface MobileMasterclassTabsProps {
    options?: SelectType[];
}
export default function MobileMasterclassTabs({ options }: MobileMasterclassTabsProps) {
    const [active, setActive] = useState<string>("Alle");
    const videos = [
        {
            title: "Antworten zur Fernbehandlung",
            description:
                "Ich zeige unzählige Mechanismen des Energiefeldes und der Fernbehandlung auf.",
            hours: "10 hrs 12 min",
            numberOfVideos: "150",
        },
    ];
    const tabs = [
        {
            value: "Kostenlos",
            title: "Kostenlos",
            numberOfVideos: "1",
            icon: (
                <Image
                    src={
                        active === "Kostenlos"
                            ? "/Icons/TabIcons/likeCyan.svg"
                            : "/Icons/TabIcons/likeGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Neu",
            title: "Neu",
            numberOfVideos: "1",
            icon: (
                <Image
                    src={
                        active === "Neu"
                            ? "/Icons/TabIcons/plusCyan.svg"
                            : "/Icons/TabIcons/plusGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Coming-soon",
            title: "Coming soon",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        active === "Coming-soon"
                            ? "/Icons/TabIcons/clockCyan.svg"
                            : "/Icons/TabIcons/clockGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Alle",
            title: "Alle",
            numberOfVideos: "1",
            icon: (
                <Image
                    src={
                        active === "Alle"
                            ? "/Icons/TabIcons/tvCyan.svg"
                            : "/Icons/TabIcons/tvGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },

        {
            value: "Kostenpflichtig",
            title: "Kostenpflichtig",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        active === "Kostenpflichtig"
                            ? "/Icons/TabIcons/paidCyan.svg"
                            : "/Icons/TabIcons/paidGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Meine-Masterclass",
            title: "Meine Masterclass",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        active === "Meine-Masterclass"
                            ? "/Icons/TabIcons/userCyan.svg"
                            : "/Icons/TabIcons/userGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
        {
            value: "Favoriten",
            title: "Favoriten",
            numberOfVideos: "0",
            icon: (
                <Image
                    src={
                        active === "Favoriten"
                            ? "/Icons/TabIcons/starCyan.svg"
                            : "/Icons/TabIcons/starGray.svg"
                    }
                    className={"relative flex-col justify-start items-start flex"}
                    alt=""
                    height={100}
                    width={100}
                />
            ),
        },
    ];
    return (
        <>
            <div className="">
                <div className="flex justify-center">
                    <SelectInput
                        onChange={(value) => setActive(value)}
                        active={active}
                        options={tabs}
                        initialOption={tabs[0]}
                    />
                </div>
                {active === "Alle" && (
                    <>
                        <div className=" ">
                            {videos.map((video) => (
                                <VideoCardDescription
                                    title={video.title}
                                    description={video.description}
                                    key={video.title}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </>
    );
}
